import React, { ReactNode } from "react";
import styles from './links.module.css';
import global from '../bid.module.css';

import { VariableLink } from "../";

type Props = {
  title: ReactNode,
  links: [
    {
      title: string,
      text: string,
      url: string,
      label: string
    }
  ],
  themeFormat: object
}

const UsefulLinks = ({ title, links, themeFormat }: Props) => {
  return (
  <section className={styles.Background} id="links" >
     <div className={`${styles.Container} ${global.Container}`}>
      <h3>{title}</h3>
      <div className={styles.Links}>
        {links.map(({ title, text, url, label }, index) => (
          <article className={styles.Link} key={title}>
            <h5>{title}</h5>
            <p>{text}</p>
            <VariableLink styledAs="button" origin='external' href={url} themeFormat={themeFormat} >
              {label}
            </VariableLink>

          </article>
        ))}
      </div>
    </div>
  </section>
)};

export default UsefulLinks;
